import React, { useEffect, useState } from 'react';
import ViewEventListItem from './ViewEventListItem';
import classNames from 'classnames';
import { browserHistory } from 'react-router';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { GAMES_WITH_1X2, MARKET_SUB_TYPE, SPORTS } from 'constants/appConfig';
import { detectMobile, scrollToTop } from '../utils/UiHelper';
import * as UiSportOverviewActions from 'actions/UiSportOverviewActions';
import { isEventInclude1X2market } from '../utils/Helper';
import ViewToggleListToolbar from '../components/ViewToggleListToolbar';
import { isTerminal } from '../utils/UiHelper';
import { validateUrlParams } from '../utils/Helper';

const ViewTournamentItems = (props) => {
    const [groupsStatus, setGroupsStatus] = useState({});
    const [scrolled, setScrolled] = useState(false);

    let eventCounter = 0;
    let isMobile = detectMobile();

    useEffect(() => {
        if (props.listType === 'toggle') {
            let groupStatusLocal = { ...props.tournamentViewStatus };
            let isOpenedFirstItem = false;

            let data = Object.values(props.data).sort((a, b) => {
                if (a.priority !== b.priority) return a.priority - b.priority;
                return a.name.localeCompare(b.name);
            });

            data.forEach((item) => {
                const key = item.id;
                if (groupStatusLocal[key] === undefined) {
                    groupStatusLocal[key] = false;
                    if (
                        !isOpenedFirstItem &&
                        props.isFirstGroupOpened === 'yes'
                    ) {
                        groupStatusLocal[key] = true;
                        isOpenedFirstItem = true;
                        props.uiSportOverviewActions.setOverviewTournamentStatus(
                            groupStatusLocal
                        );
                    } else if (
                        props.tournament?.toString() === key.toString()
                    ) {
                        groupStatusLocal[key] = true;
                    }
                }
            });

            setGroupsStatus(groupStatusLocal);
        }
        console.log('ViewTournamentItems mounted');
    }, []);

    useEffect(
        () => {
            setScrolled(false);
        },
        [props.tournament]
    );

    useEffect(() => {
        return () => {
            props.uiSportOverviewActions.setOverviewTournamentStatus(
                groupsStatus
            );
        };
    }, []);

    const _splitEventsByAwayTeam = (events) => {
        let eventsWithAwayTeam = [],
            eventsWithoutAwayTeam = [];

        events.forEach((item) => {
            if (item.awayTeam !== null) {
                eventsWithAwayTeam.push(item);
            } else {
                eventsWithoutAwayTeam.push(item);
            }
        });

        return {
            eventsWithAwayTeam: eventsWithAwayTeam,
            eventsWithoutAwayTeam: eventsWithoutAwayTeam,
        };
    };

    const _eventListSorter = (events) => {
        return events.sort((a, b) => {
            if (a.priority > b.priority) {
                return 1;
            }
            if (a.priority < b.priority) {
                return -1;
            }

            if (a.kickoff > b.kickoff) {
                return 1;
            }
            if (a.kickoff < b.kickoff) {
                return -1;
            }

            if (a.eventName) {
                if (a.eventName > b.eventName) {
                    return 1;
                }

                if (a.eventName < b.eventName) {
                    return -1;
                }
            }

            if (a.eventId > b.eventId) {
                return 1;
            }

            if (a.eventId < b.eventId) {
                return -1;
            }

            return 0;
        });
    };

    const _getList = (listType, obj) => {
        let res = {
            header: {
                1: false,
                X: false,
                2: false,
            },
            view: [],
            marketSubType: null,
        };

        if (
            obj.events[0] &&
            GAMES_WITH_1X2.includes(obj.events[0].sportId) &&
            obj.events[0].marketList &&
            isEventInclude1X2market(obj.events[0])
        ) {
            res.header['1'] = true;
            res.header['2'] = true;
            res.header['X'] = true;
        } else if (
            obj.events[0] &&
            obj.events[0].marketList &&
            isEventInclude1X2market(obj.events[0])
        ) {
            res.header['1'] = true;
            res.header['2'] = true;
        }

        if (
            listType !== 'toggle' ||
            (listType === 'toggle' && groupsStatus[obj.id])
        ) {
            let {
                eventsWithAwayTeam,
                eventsWithoutAwayTeam,
            } = _splitEventsByAwayTeam(obj.events);

            eventsWithAwayTeam = _eventListSorter(eventsWithAwayTeam).filter(
                (item) => {
                    //if event not 'live' then kickoff should be greater than current time
                    return item.liveScore || item.kickoff > Date.now();
                }
            );

            let eventIds = [];
            res.view = eventsWithAwayTeam.map((event, index) => {
                if (
                    event.marketList &&
                    (!props.limit || eventCounter < props.limit)
                ) {
                    let markets = event.marketList.filter(
                        (market) =>
                            event.defaultMarketId === market.marketId ||
                            market.mainMarket === 1 ||
                            market.marketName === 'Vinder'
                    );

                    if (markets[0] && markets[0].itemList) {
                        if (!res.marketSubType) {
                            res.marketSubType = markets[0].marketSubType;
                        }
                        markets[0].itemList.map((item) => {
                            if (item?.bet === '1' && item?.odds > 1) {
                                res.header['1'] = true;
                            } else if (
                                item?.bet?.toUpperCase() === 'X' &&
                                item?.odds > 1
                            ) {
                                res.header['X'] = true;
                            } else if (item.bet === '2' && item.odds > 1) {
                                res.header['2'] = true;
                            }

                            return item;
                        });
                    }

                    if (eventIds.indexOf(event.eventId) === -1) {
                        eventIds.push(event.eventId);
                        eventCounter++;
                        return (
                            <li
                                className="view-event-list-item-wrapper"
                                key={`${index}_${event.eventId}`}
                            >
                                <ViewEventListItem
                                    header={res.header}
                                    event={event}
                                    showFavorites={props.showFavorites}
                                />
                            </li>
                        );
                    }
                }

                return (
                    <li
                        className="view-event-list-item-wrapper"
                        key={`${event.eventId}_${index}`}
                    >
                        <ViewEventListItem
                            header={res.header}
                            event={event}
                            showFavorites={props.showFavorites}
                        />
                    </li>
                );
            });

            eventsWithoutAwayTeam = _eventListSorter(eventsWithoutAwayTeam);

            let withoutAwayTeamViews = eventsWithoutAwayTeam.map((event) => {
                if (
                    !res.marketSubType &&
                    event.marketList &&
                    event.marketList[0]
                ) {
                    res.marketSubType = event.marketList[0].marketSubType;
                }
                let isVinderspil =
                    event.marketList &&
                    event.marketList[0] &&
                    event.marketList[0].marketTypeName &&
                    event.marketList[0].marketTypeName.indexOf('Vinderspil') >
                        -1;
                if (eventIds.indexOf(event.eventId) === -1) {
                    eventIds.push(event.eventId);
                    /* show '1x2' marks in header only if it is not 'vinderspil' */
                    if (!isVinderspil) {
                        res.header = {
                            1: true,
                            X: true,
                            2: true,
                        };
                    }
                    return (
                        <li
                            className="view-event-list-item-wrapper"
                            key={event.eventId}
                        >
                            <ViewEventListItem
                                header={res.header}
                                event={event}
                                showFavorites={props.showFavorites}
                            />
                        </li>
                    );
                } else {
                    return (
                        <li
                            className="view-event-list-item-wrapper"
                            key={event.eventId}
                        >
                            <ViewEventListItem
                                header={res.header}
                                event={event}
                                showFavorites={props.showFavorites}
                            />
                        </li>
                    );
                }
            });

            res.view = res.view.concat(withoutAwayTeamViews);
        }

        return res;
    };

    const _getSubheader = (options, className = '') => {
        return (
            <div className={className}>
                {options['2'] ? (
                    <div className="text-center col-33 float-right">2</div>
                ) : !options['2'] && options['X'] ? (
                    <div className="text-center col-33 float-right market-label-placeholder">
                        &nbsp;
                    </div>
                ) : null}
                {options['X'] ? (
                    <div className="text-center col-33 float-right">X</div>
                ) : null}
                {options['1'] && !options['X'] && !options['2'] ? (
                    <div className="text-center col-33 float-right market-label-placeholder">
                        &nbsp;
                    </div>
                ) : null}
                {options['1'] ? (
                    <div className="text-center col-33 float-right">1</div>
                ) : (
                    <div className="text-center col-33 float-right market-label-placeholder">
                        &nbsp;
                    </div>
                )}
            </div>
        );
    };

    const isLivePageLocation = () => {
        return window.location.pathname === '/live';
    };

    const isFavoriteIconShow = (isLive) => {
        return isLive && isLivePageLocation();
    };

    const getPeriodLength = (obj) => {
        return obj?.events?.[0]?.periodLength &&
            obj?.events?.[0]?.periodLength > 0
            ? `- ${obj?.events?.[0]?.periodLength}  min`
            : null;
    };

    const _getHeader = (listType, obj, key, options) => {
        const isFootball =
            obj.events[0] && obj.events[0].sportId === SPORTS.FOOTBALL;
        const isLive = obj.events.every((item) => item.live);

        if (listType === 'simple') return null;
        if (listType === 'toggle') {
            let opened = groupsStatus[obj.id] ? 'yes' : 'no';
            let {
                eventsWithAwayTeam,
                eventsWithoutAwayTeam,
            } = _splitEventsByAwayTeam(obj.events);
            let eventsForList = eventsWithAwayTeam.concat(
                eventsWithoutAwayTeam
            );

            let listToolbar = (
                <ViewToggleListToolbar
                    title={obj.name}
                    tournamentId={obj.id}
                    toggleHandler={toggleHandler}
                    opened={opened}
                    infoIcon={
                        props.sportInfo
                            ? obj &&
                              props.sportInfo.comp &&
                              props.sportInfo.comp[obj.id]
                                ? props.sportInfo.comp[obj.id].content
                                : null
                            : null
                    }
                />
            );

            /* if all events belong to 'vinderspil' type - hide marks 'under/over' */
            let vinderspilQuantity = 0;
            obj.events.forEach((event) => {
                if (
                    event.marketList &&
                    event.marketList[0] &&
                    event.marketList[0].marketTypeName &&
                    event.marketList[0].marketTypeName.indexOf('Vinderspil') >
                        -1
                )
                    vinderspilQuantity++;
            });
            let onlyVinderspilTypes = vinderspilQuantity === obj.events.length;

            let subHeader = (
                <div className="view-event-list-subtitle row">
                    <div
                        className={classNames('three-dots', {
                            'col-4': !detectMobile(),
                            'col-45': detectMobile(),
                        })}
                    >
                        <span className="pl10">
                            {props.sport}/ {props.group.name}/ {obj.name}{' '}
                            {getPeriodLength(obj)}
                        </span>
                    </div>

                    {isMobile &&
                        _getSubheader(
                            options,
                            classNames('primary-bet-label-section row', {
                                'col-45': isLive,
                                'col-55': !isLive,
                            })
                        )}

                    {!isMobile && (
                        <div className="col-5 row">
                            {_getSubheader(
                                options,
                                classNames('primary-bet-label-section', {
                                    'col-55': isFootball,
                                })
                            )}
                            {!onlyVinderspilTypes && isFootball ? (
                                <React.Fragment>
                                    <div className="col-05">&nbsp;</div>
                                    <div className="col-4 row">
                                        <div className="text-center">
                                            Antal mål i kampen
                                        </div>
                                    </div>
                                </React.Fragment>
                            ) : null}
                        </div>
                    )}
                </div>
            );

            if (isTerminal()) {
                /** for Terminals don't show listToolbar if there no events */
                if (eventsForList.length === 0) {
                    listToolbar = null;
                    subHeader = null;
                }
            }

            /** show list only if toolbar opened*/
            if (opened !== 'yes') {
                subHeader = null;
            }

            return (
                <div id={'tournament-id-' + obj.id}>
                    {listToolbar}
                    {subHeader}
                </div>
            );
        } else {
            if (options['1'] || options['X'] || options['2']) {
                return (
                    <div className="view-event-list-subtitle row">
                        <div
                            className={classNames('three-dots', {
                                'col-4': !detectMobile(),
                                'col-45': detectMobile(),
                            })}
                        >
                            <span className="pl10">
                                {props.sport}/ {props.group.name}/ {obj.name}{' '}
                                {getPeriodLength(obj)}
                            </span>
                        </div>

                        {isMobile &&
                            _getSubheader(
                                options,
                                'primary-bet-label-section row col-55'
                            )}

                        {!isMobile && (
                            <div className="col-5 row">
                                {_getSubheader(
                                    options,
                                    classNames('primary-bet-label-section', {
                                        'col-55': isFootball,
                                    })
                                )}
                                {obj.events[0] &&
                                    isFootball && (
                                        <React.Fragment>
                                            <div className="col-05">&nbsp;</div>
                                            <div className="col-4 row">
                                                <div className="text-center">
                                                    Antal mål i kampen
                                                </div>
                                            </div>
                                        </React.Fragment>
                                    )}
                            </div>
                        )}
                    </div>
                );
            } else {
                return (
                    <div className="view-event-list-subtitle row">
                        <div className="col-5 three-dots">
                            <span className="pl10">
                                {props.sport}/ {props.group.name}/ {obj.name}{' '}
                                {getPeriodLength(obj)}
                            </span>
                        </div>
                        <div className="col-4 row" />
                    </div>
                );
            }
        }
    };

    const buildNewPath = (tournamentId) => {
        const pathnameArray = window.location.pathname.split('/');
        const sport = encodeURIComponent(pathnameArray[1]);
        const category = encodeURIComponent(pathnameArray[2]);
        const tournamentData = props.data[tournamentId];
        const groupName = encodeURIComponent(
            tournamentData?.events?.[0]?.groupName
                .toLowerCase()
                .replace(/\s+/g, '-')
        );
        const tournamentName = encodeURIComponent(
            validateUrlParams(tournamentData.name)
        );
        return `/${sport}/${category}/${groupName}/${tournamentName}`;
    };

    const toggleHandler = (status, tournamentId) => {
        //TODO check comparison prev state and updated
        const updatedStatus = {
            ...groupsStatus,
            [tournamentId]: !props.tournamentViewStatus[tournamentId],
        };
        setScrollPosition(updatedStatus[tournamentId], tournamentId, scrolled);
        props.uiSportOverviewActions.setOverviewTournamentStatus(updatedStatus);
        setGroupsStatus(updatedStatus);

        if (status) {
            if (status) {
                const newPath = buildNewPath(tournamentId);
                browserHistory.push(newPath);
            }
            setScrolled(true);
        }
    };

    const setScrollPosition = (status, id, scrolled) => {
        console.log('setScrollPosition');
        if (status) {
            setTimeout(() => {
                let rect = document
                    .querySelector('#tournament-id-' + id)
                    ?.getBoundingClientRect();
                let elOffset = rect?.top + window.scrollY;
                let differences = detectMobile() ? 142 : 140;
                if (elOffset && differences) {
                    window.scrollTo({
                        top: elOffset - differences,
                        behavior: 'smooth',
                    });
                }
            }, 500);

            setScrolled(true);
        }
    };

    eventCounter = 0;

    let data = Object.values(props.data).sort((a, b) => {
        if (a.priority > b.priority) {
            return 1;
        }

        if (a.priority < b.priority) {
            return -1;
        }

        if (a.name > b.name) {
            return 1;
        }
        if (a.name < b.name) {
            return -1;
        }

        return 0;
    });
    const listType = props.listType;

    const views = data
        .map((obj, key) => {
            const eventsList = _getList(listType, obj);
            const headerView = _getHeader(
                listType,
                obj,
                key,
                eventsList.header
            );
            const betsAvailable = [
                eventsList.header['1'],
                eventsList.header['X'],
                eventsList.header['2'],
            ].filter((item) => item).length;

            return (
                <div
                    key={obj.id}
                    // TODO tabs
                    className={classNames('view-event-list-row-item', {
                        mobile: detectMobile(),
                        'market-1x2':
                            eventsList.marketSubType ===
                            MARKET_SUB_TYPE.MAIN_1X2,
                        'no-bets': betsAvailable === 0,
                        'one-bet': betsAvailable === 1,
                        'two-bets': betsAvailable === 2,
                        'with-favicon': isFavoriteIconShow(
                            obj.events.every(
                                (item) => item.live && item.liveScore
                            )
                        ),
                    })}
                >
                    {headerView}
                    <ul className="view-event-list-wrapper">
                        {eventsList.view}
                    </ul>
                </div>
            );
        })
        .filter((item) => item);

    return views;
};

const mapStateToProps = (state) => {
    return {
        tournamentViewStatus: state.uiSportOverview.tournamentViewStatus,
        tournamentId: state.uiSportOverview.tournamentId,
        danmarkItems: state.ui.danmarkItems,
        sportInfo: state.sportTree.sportInfo,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        uiSportOverviewActions: bindActionCreators(
            UiSportOverviewActions,
            dispatch
        ),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ViewTournamentItems);
